/**
 * @generated SignedSource<<4f090ffa5a9540450db25bb2c54f41b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TradeRule",
    "kind": "LinkedField",
    "name": "cancelNominatedTrade",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CancelNominatedTradeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CancelNominatedTradeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "93ef7464c29b7e3c4d2f0cc8c9be0354",
    "id": null,
    "metadata": {},
    "name": "CancelNominatedTradeMutation",
    "operationKind": "mutation",
    "text": "mutation CancelNominatedTradeMutation(\n  $id: ID!\n) {\n  cancelNominatedTrade(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "a93f13c2cb9c7d02440a5de06c7dc4f1";

module.exports = node;
